export default "https://cdn-static.gokick.com/assets/10f8238ac2c3e70096f19214fcd9b55856558067/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";